<script setup lang="ts">
import { onBeforeUnmount } from 'vue';
import { useRequestCancel } from '@/composables';
import UserHeader from './components/UserHeader';

const requestCancel = useRequestCancel();

onBeforeUnmount(() => requestCancel.requestSaverAbortAll());
</script>

<template>
  <div class="page-container users-page-container">
    <UserHeader />
    <RouterView />
  </div>
</template>

<style lang="scss" scoped></style>
